import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, BedDouble, Users, UserCog, LogOut, ExternalLink, Settings, Images } from "lucide-react";
import { useAuth } from "./AuthContext";
import { Logo } from "../components/Logo";

export function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  const links = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/admin/habitaciones", label: "Habitaciones", icon: BedDouble },
    { to: "/admin/prospectos", label: "Prospectos", icon: Users },
  ];
  if (user?.role === "super_admin") {
    links.push({ to: "/admin/usuarios", label: "Usuarios", icon: UserCog });
    links.push({ to: "/admin/galeria", label: "Galería", icon: Images });
    links.push({ to: "/admin/configuracion", label: "Configuración", icon: Settings });
  }

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-5 py-3 text-sm font-light transition-colors ${
      isActive ? "bg-white/10 text-white border-l-2 border-white" : "text-white/60 hover:text-white hover:bg-white/5 border-l-2 border-transparent"
    }`;

  return (
    <div className="min-h-screen flex bg-[#F5F1EA] font-poppins">
      {/* Sidebar */}
      <aside className="w-64 bg-[#7D5A44] flex flex-col fixed h-full" data-testid="admin-sidebar">
        <div className="px-6 py-6 border-b border-white/10">
          <Logo light heightClass="h-10" />
        </div>
        <nav className="flex-1 py-6">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={linkClass} data-testid={`nav-${l.label.toLowerCase()}`}>
              <l.icon size={18} strokeWidth={1.6} />
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-5 py-5 border-t border-white/10">
          <div className="text-xs text-white/40 mb-1">{user?.email}</div>
          <div className="text-[10px] uppercase tracking-wide text-white/30 mb-4">
            {user?.role === "super_admin" ? "Super Admin" : "Admin"}
          </div>
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-xs font-light text-white/60 hover:text-white mb-3"
          >
            <ExternalLink size={14} /> Ver sitio público
          </a>
          <button
            onClick={handleLogout}
            data-testid="logout-btn"
            className="flex items-center gap-2 text-xs font-light text-white/60 hover:text-white"
          >
            <LogOut size={14} /> Cerrar sesión
          </button>
        </div>
      </aside>

      {/* Content */}
      <main className="flex-1 ml-64 p-10">
        <Outlet />
      </main>
    </div>
  );
}
